import { observable, action, computed, makeAutoObservable } from 'mobx';

export class SelectState {
    @observable value: string | null;
    @observable isFocus: boolean = false;
    @observable isError: boolean = false;

    constructor(value: string) {
        this.value = value ?? null;
        makeAutoObservable(this);
    }

    @action handleFocus = (): void => {
        this.isFocus = true;
        this.isError = false;
    };

    @action handleBlur = (): void => {
        this.isFocus = false;
    };

    @computed get currentValue(): string {
        if (this.value !== null) {
            return this.value;
        }
        return '';
    }

    @computed get isSelected(): boolean {
        if (this.value === null) {
            return false;
        }
        return this.value.length !== 0;
    }
}
